export default function () {
  this.loadPlans()
}
